import React from 'react'
import styled from 'styled-components'

const Chip = styled.sup`
  display: inline-block;
  background: #fbede9;
  color: #d24724;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  margin: 0 1px;
  vertical-align: super;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #d24724;
    color: #fff;
  }
`

const WikiCitationChip = ({ marker, refId, onActivate }) => (
  <Chip
    title={refId}
    onClick={() => onActivate?.(refId, marker)}
  >
    {marker}
  </Chip>
)

export default WikiCitationChip
